import { MerchantTypeForm } from "./Main";

export const Register = () => {
  return <MerchantTypeForm />;
};
